import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { mockUsers } from '~/shared/fixtures';
import type { User } from '~/shared/types/user';

export interface UseUserResult {
  user: User | undefined;
  isLoading: boolean;
}

/**
 * Returns a user by route param :userId (for view profile).
 * TODO(backend): Replace with useQuery(USER_QUERY, { variables: { userId } }) when backend implements; remove mockUsers.
 */
export function useUser(): UseUserResult {
  const { userId } = useParams<{ userId: string }>();

  return useMemo<UseUserResult>(() => {
    if (!userId) {
      return { user: undefined, isLoading: false };
    }
    const numericId = Number(userId);
    if (Number.isNaN(numericId)) {
      return { user: undefined, isLoading: false };
    }
    const user = mockUsers.find((u) => u.id === numericId);
    return { user, isLoading: false };
  }, [userId]);
}
